import { useState, useEffect } from 'react';
import { supabase } from '../supabase';

function FluxoCaixa() {
  const hoje = new Date();
  const [dataInicio, setDataInicio] = useState(() => {
    const d = new Date(hoje);
    d.setDate(d.getDate() - d.getDay()); // início da semana atual
    return d.toISOString().split('T')[0];
  });
  const [dataFim, setDataFim] = useState(() => {
    const d = new Date(hoje);
    d.setDate(d.getDate() - d.getDay() + 6); // fim da semana atual
    return d.toISOString().split('T')[0];
  });
  const [dados, setDados] = useState(null);
  const [carregando, setCarregando] = useState(true);

  const formatarMoeda = (valor) => Number(valor || 0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
  const formatarData = (data) => new Date(data + 'T12:00:00').toLocaleDateString('pt-BR');

  useEffect(() => {
    if (dataInicio && dataFim) buscarDados();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataInicio, dataFim]);

  const buscarDados = async () => {
    setCarregando(true);

    const inicio = new Date(dataInicio + 'T00:00:00');
    const fim = new Date(dataFim + 'T23:59:59');

    const mesesNoPeriodo = [];
    const d = new Date(inicio);
    while (d <= fim) {
      const mes = String(d.getMonth() + 1);
      const ano = String(d.getFullYear());
      if (!mesesNoPeriodo.find(m => m.mes === mes && m.ano === ano)) {
        mesesNoPeriodo.push({ mes, ano });
      }
      d.setDate(d.getDate() + 1);
    }

    // Busca clientes
    const { data: clientes } = await supabase.from('clientes').select('*').eq('ativo', true);

    // Busca pagamentos dos meses no período
    let todasEntradas = [];
    let todasDespesas = [];

    for (const { mes, ano } of mesesNoPeriodo) {
      const { data: pagamentos } = await supabase.from('pagamentos').select('*, clientes(nome, valor, vencimento)')
        .eq('mes', mes).eq('ano', ano);

      const { data: despesas } = await supabase.from('despesas').select('*')
        .eq('mes', mes).eq('ano', ano);

      // Monta entradas com data estimada de vencimento
      (clientes || []).forEach(c => {
        const diaVenc = c.vencimento;
        const dataVenc = new Date(`${ano}-${mes.padStart(2, '0')}-${String(diaVenc).padStart(2, '0')}T12:00:00`);
        if (dataVenc >= inicio && dataVenc <= fim) {
          const pag = (pagamentos || []).find(p => p.cliente_id === c.id);
          todasEntradas.push({
            id: c.id,
            nome: c.nome,
            valor: Number(c.valor),
            data: dataVenc.toISOString().split('T')[0],
            pago: pag?.pago || false,
          });
        }
      });

      // Monta saídas com data estimada
      (despesas || []).forEach(d => {
        let dia = 1;
        if (d.categoria === 'cartao' || d.categoria === 'parcela') dia = 15;
        const dataVenc = new Date(`${ano}-${mes.padStart(2, '0')}-${String(dia).padStart(2, '0')}T12:00:00`);
        if (dataVenc >= inicio && dataVenc <= fim) {
          todasDespesas.push({
            id: d.id,
            nome: d.nome,
            valor: Number(d.valor),
            categoria: d.categoria,
            data: dataVenc.toISOString().split('T')[0],
            pago: d.pago || false,
          });
        }
      });
    }

    const totalEntradas = todasEntradas.reduce((acc, e) => acc + e.valor, 0);
    const totalSaidas = todasDespesas.reduce((acc, d) => acc + d.valor, 0);
    const saldo = totalEntradas - totalSaidas;
    const entradasPagas = todasEntradas.filter(e => e.pago).reduce((acc, e) => acc + e.valor, 0);
    const saidasPagas = todasDespesas.filter(d => d.pago).reduce((acc, d) => acc + d.valor, 0);

    setDados({ entradas: todasEntradas, saidas: todasDespesas, totalEntradas, totalSaidas, saldo, entradasPagas, saidasPagas });
    setCarregando(false);
  };

  const navegarSemana = (direcao) => {
    const inicio = new Date(dataInicio + 'T12:00:00');
    const fim = new Date(dataFim + 'T12:00:00');
    inicio.setDate(inicio.getDate() + (direcao * 7));
    fim.setDate(fim.getDate() + (direcao * 7));
    setDataInicio(inicio.toISOString().split('T')[0]);
    setDataFim(fim.toISOString().split('T')[0]);
  };

  return (
    <div>
      <div className="mb-6 flex justify-between items-center">
        <div>
          <h2 className="text-2xl font-bold text-white">Fluxo de Caixa</h2>
          <p className="text-gray-400 mt-1">Entradas e saídas no período</p>
        </div>

        {/* Navegação de período */}
        <div className="flex items-center gap-3">
          <button onClick={() => navegarSemana(-1)}
            className="px-3 py-2 bg-gray-800 text-gray-400 rounded-lg hover:bg-gray-700 hover:text-white transition-colors text-sm">
            ← Semana anterior
          </button>
          <div className="flex items-center gap-2">
            <input type="date" value={dataInicio} onChange={(e) => setDataInicio(e.target.value)}
              className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500" />
            <span className="text-gray-500">até</span>
            <input type="date" value={dataFim} onChange={(e) => setDataFim(e.target.value)}
              className="bg-gray-800 text-white rounded-lg px-3 py-2 text-sm border border-gray-700 outline-none focus:border-blue-500" />
          </div>
          <button onClick={() => navegarSemana(1)}
            className="px-3 py-2 bg-gray-800 text-gray-400 rounded-lg hover:bg-gray-700 hover:text-white transition-colors text-sm">
            Próxima semana →
          </button>
        </div>
      </div>

      {carregando ? (
        <div className="flex items-center justify-center h-64"><p className="text-gray-400">Carregando...</p></div>
      ) : (
        <>
          {/* Cards de resumo */}
          <div className="grid grid-cols-4 gap-4 mb-6">
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <p className="text-gray-400 text-sm">Entradas Previstas</p>
              <p className="text-2xl font-bold text-green-400 mt-1">{formatarMoeda(dados.totalEntradas)}</p>
              <p className="text-xs text-gray-500 mt-1">Recebido: {formatarMoeda(dados.entradasPagas)}</p>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <p className="text-gray-400 text-sm">Saídas Previstas</p>
              <p className="text-2xl font-bold text-red-400 mt-1">{formatarMoeda(dados.totalSaidas)}</p>
              <p className="text-xs text-gray-500 mt-1">Pago: {formatarMoeda(dados.saidasPagas)}</p>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <p className="text-gray-400 text-sm">Saldo do Período</p>
              <p className={`text-2xl font-bold mt-1 ${dados.saldo >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                {formatarMoeda(dados.saldo)}
              </p>
            </div>
            <div className="bg-gray-900 rounded-xl p-5 border border-gray-800">
              <p className="text-gray-400 text-sm">Saldo Real</p>
              <p className={`text-2xl font-bold mt-1 ${(dados.entradasPagas - dados.saidasPagas) >= 0 ? 'text-green-400' : 'text-red-400'}`}>
                {formatarMoeda(dados.entradasPagas - dados.saidasPagas)}
              </p>
              <p className="text-xs text-gray-500 mt-1">Só o que entrou/saiu</p>
            </div>
          </div>

          <div className="grid grid-cols-2 gap-6">
            {/* Entradas */}
            <div className="bg-gray-900 rounded-xl border border-gray-800">
              <div className="p-5 border-b border-gray-800 flex justify-between items-center">
                <h3 className="text-white font-semibold">💰 Entradas</h3>
                <span className="text-xs text-gray-500">{dados.entradas.length} itens</span>
              </div>
              {dados.entradas.length === 0 ? (
                <p className="p-6 text-center text-gray-500 text-sm">Nenhuma entrada neste período.</p>
              ) : (
                <div className="divide-y divide-gray-800">
                  {dados.entradas.map((e) => (
                    <div key={e.id} className="p-4 flex justify-between items-center">
                      <div>
                        <p className={`text-sm font-medium ${e.pago ? 'text-white' : 'text-gray-300'}`}>{e.nome}</p>
                        <p className="text-xs text-gray-500 mt-0.5">Vence {formatarData(e.data)}</p>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="text-green-400 font-medium text-sm">{formatarMoeda(e.valor)}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${e.pago ? 'bg-green-500/20 text-green-400' : 'bg-yellow-500/20 text-yellow-400'}`}>
                          {e.pago ? 'Recebido' : 'Pendente'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>

            {/* Saídas */}
            <div className="bg-gray-900 rounded-xl border border-gray-800">
              <div className="p-5 border-b border-gray-800 flex justify-between items-center">
                <h3 className="text-white font-semibold">💸 Saídas</h3>
                <span className="text-xs text-gray-500">{dados.saidas.length} itens</span>
              </div>
              {dados.saidas.length === 0 ? (
                <p className="p-6 text-center text-gray-500 text-sm">Nenhuma saída neste período.</p>
              ) : (
                <div className="divide-y divide-gray-800 max-h-96 overflow-auto">
                  {dados.saidas.map((d) => (
                    <div key={d.id} className="p-4 flex justify-between items-center">
                      <div>
                        <p className="text-sm font-medium text-gray-300">{d.nome}</p>
                        <div className="flex items-center gap-2 mt-0.5">
                          <p className="text-xs text-gray-500">Vence {formatarData(d.data)}</p>
                          <span className={`text-xs px-1.5 py-0.5 rounded-full ${
                            d.categoria === 'fixa' ? 'bg-blue-500/20 text-blue-400' :
                            d.categoria === 'cartao' ? 'bg-purple-500/20 text-purple-400' :
                            'bg-orange-500/20 text-orange-400'
                          }`}>
                            {d.categoria === 'fixa' ? 'Fixa' : d.categoria === 'cartao' ? 'Cartão' : 'Parcela'}
                          </span>
                        </div>
                      </div>
                      <div className="flex items-center gap-3">
                        <span className="text-red-400 font-medium text-sm">{formatarMoeda(d.valor)}</span>
                        <span className={`text-xs px-2 py-0.5 rounded-full ${d.pago ? 'bg-green-500/20 text-green-400' : 'bg-red-500/20 text-red-400'}`}>
                          {d.pago ? 'Pago' : 'Pendente'}
                        </span>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </div>
        </>
      )}
    </div>
  );
}

export default FluxoCaixa;